import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Empty,
  Flex,
  Menu,
  Input,
  message,
  Space,
  Spin,
  Tooltip,
  Typography,
  Dropdown,
  Skeleton,
  Segmented,
} from "antd";
import {
  SearchOutlined,
  FilterOutlined,
  DownloadOutlined,
  PlusOutlined,
  ReloadOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  EnvironmentOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  InboxOutlined,
  PushpinOutlined,
} from "@ant-design/icons";
import CreateForum from "./CreateForum";
import api from "../../../api";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import RejectionModal from "../Approval/RejectionModal";

const { Title, Text } = Typography;

const Forum = () => {
  const [isForumModalVisible, setForumModalVisible] = useState(false);
  const [filterType, setFilterType] = useState("All");
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [pageSize, setPageSize] = useState(10);
  const [forumData, setForumData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openRejectionModal, setOpenRejectionModal] = useState(false);
  const [editForumData, setEditForumData] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const [visibilityFilter, setVisibilityFilter] = useState("All");
  const [currentForumData, setCurrentForumData] = useState(null)
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = forumData.slice(startIndex, endIndex);
  const totalItems = forumData.length;
  const totalPages = Math.ceil(totalItems / pageSize);

  const getForumData = async () => {
    setLoading(true);
    try {
      const requestData = {
        synceddatetime: "2025-05-29 10:08:00",
        FormCode: "201",
        AppVersion: "1.0.0.0",
        ApiKey: "kavin",
        AppTypeNo: "3",
      };
      const response = await api.getForumList(requestData);


      if (response.data.status === "1") {
        setForumData(response.data.services_products_data || []);
      } else {
        setForumData([]);
      }
    } catch (err) {
      console.error(err);
      messageApi.error("Failed to fetch forum data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getForumData();
  }, []);



  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const handleEditForum = (forum) => {
    setEditForumData(forum);
    setForumModalVisible(true);
  };

  const handleCloseForumModal = () => {
    setForumModalVisible(false);
    setEditForumData(null);
  };



  const filteredData = forumData.filter((forum) => {
    const matchesSearch = forum.fld_forum_title?.toLowerCase().includes(searchTerm);

    const matchesStatus =
      statusFilter === "All" ||
      (statusFilter === "Active" && forum.fld_threads_status_name === "Active") ||
      (statusFilter === "Inactive" && forum.fld_threads_status_name === "Inactive");

    const matchesVisibility =
      visibilityFilter === "All" ||
      (visibilityFilter === "Private" && forum.fld_thread_type_name === "Private") ||
      (visibilityFilter === "Public" && forum.fld_thread_type_name === "Public");

    return matchesSearch && matchesStatus && matchesVisibility;
  });

  const displayedData = filteredData.slice(startIndex, endIndex);

  const handlePageSizeChange = (size) => {
    setPageSize(Number(size));
    setCurrentPage(1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const pageMenu = (
    <Menu
      items={[5, 10, 25, 50].map((num) => ({
        key: num,
        label: num.toString(),
        onClick: () => handlePageSizeChange(num),
      }))}
    />
  );

  //  const typeMenu = (
  //     <Menu
  //       items={[
  //         {
  //           key: "Online",
  //           label: "Online",
  //           onClick: () => {
  //             setSelectedType("Online");
  //             setFilteredData(
  //               eventData.filter((ev) => ev.fld_event_type_name === "Online")
  //             );
  //             setCurrentPage(1);
  //           },
  //         },
  //         {
  //           key: "Offline",
  //           label: "Offline",
  //           onClick: () => {
  //             setSelectedType("Offline");
  //             setFilteredData(
  //               eventData.filter((ev) => ev.fld_event_type_name === "Offline")
  //             );
  //             setCurrentPage(1);
  //           },
  //         },
  //       ]}
  //     />
  //   );

  const handleResetFilters = () => {
    setStatusFilter("All");
    setVisibilityFilter("All");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const handleFilterTypeChange = () => { }

  const handleDeleteForum = async (reason) => {
    try {
      const payload = {
        "synceddatetime": "2025-05-29 10:08:00",
        "FormCode": "201",
        "AppVersion": "1.0.0.0",
        "ApiKey": "kavin",
        "AppTypeNo": "3",
        "fld_rf_id": currentForumData?.fld_rf_id,
        "fld_reason_for_deletion": reason ? reason : ""
      }

      const response = await api.deleteForum(payload);

      if (response?.data?.status === "1") {
        messageApi.success("Forum deleted successfully");
        getForumData();
      }
    } catch (err) {
      console.error("Forum Delete Error:", err);
      messageApi.error("Failed to delete Forum");
    }

  }

  const ForumSkeleton = () => (
    <Card className="review-card">
      <Flex align="center" justify="space-between">
        {/* Left Side */}
        <Flex align="center" gap={16}>
          <Skeleton.Image
            active
            style={{
              width: 80,
              height: 80,
            }}  
          />

          <div>
            <Skeleton.Input
              active
              size="small"
              style={{
                width: 220,
                height: 16,
                marginBottom: 8,
              }}
            />

            <Skeleton.Input
              active
              size="small"
              style={{
                width: 350,
                height: 14,
                marginBottom: 8,
              }}
            />

            <div style={{ display: "flex", gap: 8 }}>
              <Skeleton.Button
                active
                size="small"
                style={{ width: 90 }}
              />

              <Skeleton.Button
                active
                size="small"
                style={{ width: 80 }}
              />

              <Skeleton.Button
                active
                size="small"
                style={{ width: 80 }}
              />
            </div>
          </div>
        </Flex>

        {/* Right Side */}
        <Space>
          <Skeleton.Button active size="small" />
          <Skeleton.Button active size="small" />
        </Space>
      </Flex>

      <div style={{ marginTop: 12 }}>
        <Skeleton.Input
          active
          size="small"
          style={{
            width: 180,
            height: 12,
          }}
        />
      </div>
    </Card>
  );

  return (
    <>
      {isForumModalVisible && (
        <CreateForum
          visible={isForumModalVisible}
          onClose={handleCloseForumModal}
          onSuccess={getForumData}
          editdata={editForumData}
        />
      )}



      <div className="review-page">
        {contextHolder}
        {/* Header */}
        <Flex
          className="review-header"
          justify="space-between"
          align="center"
          style={{ marginBottom: 16 }}
        >
          <Input
            className="review-search"
            prefix={<SearchOutlined />}
            placeholder="Search forums..."
            value={searchTerm}
            onChange={handleSearch}
            style={{ width: 300 }}
          />
          <Space>
            {/* <Button icon={<DownloadOutlined />} className="review-export-btn">
                Export
              </Button> */}
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setForumModalVisible(true)}
              style={{ backgroundColor: '#0072b1' }}
            >
              Create Forum
            </Button>
          </Space>
        </Flex>

        {/* Main Section */}
        <div className="review-container">
          <div className="review-heading">
            <Title level={4} style={{ margin: 0 }}>
              Forum Management
            </Title>
            <Text type="secondary">
              Manage, publish, and edit your community forums
            </Text>
          </div>
          <div className="review-filters">
            <div className="filter-buttons">
              {/* <Button icon={<FilterOutlined />}  /> */}
              <Tooltip title="Filter Active or Inactive Forum">
                <Dropdown
                  overlay={
                    <Menu
                      items={[
                        { key: "All", label: "All", onClick: () => { setStatusFilter("All"); setCurrentPage(1); } },
                        { key: "Active", label: "Active", onClick: () => { setStatusFilter("Active"); setCurrentPage(1); } },
                        { key: "Inactive", label: "Inactive", onClick: () => { setStatusFilter("Inactive"); setCurrentPage(1); } },
                      ]}
                    />
                  }
                  trigger={["click"]}
                >
                  <Button>
                    {statusFilter} <DownOutlined />
                  </Button>
                </Dropdown>
              </Tooltip>

              {/* ✅ Visibility Dropdown */}
              <Tooltip title="Filter Private or Public Forum ">
                <Dropdown
                  overlay={
                    <Menu
                      items={[
                        { key: "All", label: "All", onClick: () => { setVisibilityFilter("All"); setCurrentPage(1); } },
                        { key: "Private", label: "Private", onClick: () => { setVisibilityFilter("Private"); setCurrentPage(1); } },
                        { key: "Public", label: "Public", onClick: () => { setVisibilityFilter("Public"); setCurrentPage(1); } },
                      ]}
                    />
                  }
                  trigger={["click"]}
                >
                  <Button>
                    {visibilityFilter} <DownOutlined />
                  </Button>
                </Dropdown>
              </Tooltip>




              <Button
                icon={<ReloadOutlined />}
                className="reset-btn"
                onClick={handleResetFilters}
              >
                Reset Filter
              </Button>
            </div>

            {/* <Segmented
              className="review-toggle"
              options={["All", "Upcoming", "Complete"]}
              value={filterType}
              onChange={handleFilterTypeChange}
            /> */}
          </div>

          {/* Content Cards */}
          <div className="review-card-list" style={{ marginTop: 16 }}>
            {loading ? (
              Array.from({ length: 6 }).map((_, index) => (
                <ForumSkeleton key={index} />
              ))
            ) : displayedData.length === 0 ? (
              <Card className="nodata-card">
                <Empty
                  description="No forum data available"
                  image={
                    <InboxOutlined
                      style={{ fontSize: 48, color: "#d9d9d9" }}
                    />
                  }
                />
              </Card>
            ) : (
              displayedData.map((forum, index) => (
                <Card
                  key={forum.fld_forum_id || index}
                  className="review-card"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate(`forum/${forum?.fld_rf_id}`, {
                      state: { forumData: forum },
                    });
                  }}
                >
                  <Flex align="center" justify="space-between">
                    {/* Left Content */}
                    <Flex align="center" gap={16}>
                      <img
                        src={forum.fld_cover_image_url}
                        alt="forum cover"
                        style={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 8,
                          background: "#f0f0f0",
                        }}
                      />
                      <div>
                        <Text strong style={{ fontSize: 16 }}>
                          {forum.fld_forum_title || "Untitled Forum"}
                        </Text>
                        <div style={{ color: "#888", fontSize: 13 }}>
                          {forum.fld_forum_description?.length > 80
                            ? forum.fld_forum_description.slice(0, 80) + "..."
                            : forum.fld_forum_description || "No description"}
                        </div>
                        <div style={{ marginTop: 4 }}>
                          <Badge
                            color="#dcce37ff"
                            text={forum.fld_category_name || "Uncategorized"}
                          />
                          <Badge
                            color={forum.fld_thread_type_name === 'Private' ? "#e30846ff" : "#378bffff"}
                            text={forum.fld_thread_type_name || "Thread"}
                            style={{ marginLeft: 8 }}
                          />
                          <Badge
                            color={forum.fld_threads_status_name === 'Active' ? "#22d324ff" : "#170c0cff"}
                            text={
                              forum.fld_threads_status_name || "Unknown Status"
                            }
                            style={{ marginLeft: 8 }}
                          />
                        </div>
                      </div>
                    </Flex>

                    {/* Right Content */}
                    <Space size={8} className="forum-actions">
                      {/* <Tooltip title="View Forum Details">
                          <Button
                            icon={<EyeOutlined />}
                            size="small"
                            style={{
                              borderRadius: 6,
                              borderColor: "#ccc",
                              color: "#555",
                              background: "white",
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`forum/${forum?.fld_rf_id}`, {
                                state: { forumData: forum },
                              });
                            }}
                          >
                            View
                          </Button>
                        </Tooltip> */}

                      <Tooltip title="Edit this Forum">
                        <Button
                          icon={<EditOutlined />}
                          size="small"
                          style={{
                            borderRadius: 6,
                            borderColor: "#ccc",
                            color: "#555",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditForum(forum)
                          }
                          }
                        >
                          Edit
                        </Button>
                      </Tooltip>

                      <Tooltip title="Delete this Forum">
                        <Button
                          icon={<DeleteOutlined />}
                          size="small"
                          style={{
                            borderRadius: 6,
                            borderColor: "#ccc",
                            color: "#d9534f",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentForumData(forum);
                            setOpenRejectionModal(true);
                          }}
                        >
                          Delete
                        </Button>
                      </Tooltip>
                      {forum.fld_pin_unpin_id === "1" &&
                        <Tooltip title="Pinned Forum">
                          <PushpinOutlined style={{ color: "#ff4d07ff", fontSize: 20 }} />

                        </Tooltip>}
                    </Space>

                  </Flex>
                  {/* Footer section: Date, Sponsor, Stats */}
                  <Flex
                    justify="space-between"
                    align="center"
                    style={{ marginTop: 8, color: "#999", fontSize: 12 }}
                  >
                    <div>
                      Added on{" "}
                      {forum.fld_system_inserted_datetime
                        ? dayjs(forum.fld_system_inserted_datetime).format("D MMM YYYY, h:mm A")
                        : "N/A"}{" "}
                      {/* | Sponsor: {forum.fld_sponcer_name || forum.fld_is_sponsored_name || "N/A"} */}
                    </div>

                    {/* Stats Section */}
                    {/* <Space size={16}>
                        <Tooltip title="Likes">
                          <span>
                            <span
                              style={{
                                color: "#ff4d4f",
                                marginRight: 4,
                                fontSize: 14,
                              }}
                            >
                              ❤️
                            </span>
                            {forum.fld_likes_count || 100}
                          </span>
                        </Tooltip>

                        <Tooltip title="Replies">
                          <span>
                            <span
                              style={{
                                color: "#52c41a",
                                marginRight: 4,
                                fontSize: 14,
                              }}
                            >
                              💬
                            </span>
                            {forum.fld_replies_count || 10}
                          </span>
                        </Tooltip>

                        <Tooltip title="Views">
                          <span>
                            <span
                              style={{
                                color: "#1890ff",
                                marginRight: 4,
                                fontSize: 14,
                              }}
                            >
                              👁️
                            </span>
                            {forum.fld_views_count || 300}
                          </span>
                        </Tooltip>
                      </Space> */}
                  </Flex>

                </Card>
              ))
            )}
          </div>

          {/* Pagination */}

          <div
            className="review-pagination"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
              marginTop: 20,
            }}
          >
            <Button
              icon={<LeftOutlined />}
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            />
            <span className="page-info">
              Page {currentPage} of {totalPages || 1}
            </span>
            <Button
              icon={<RightOutlined />}
              onClick={handleNextPage}
              disabled={currentPage === totalPages || totalPages === 0}
            />
            <Dropdown overlay={pageMenu} trigger={["click"]}>
              <Button>
                {pageSize} / page <DownOutlined />
              </Button>
            </Dropdown>
          </div>

        </div>
      </div>
      {openRejectionModal === true &&
        <RejectionModal
          title='Delete Forum'
          content='Are you sure you want to Delete this Forum ?  Later you cannot undo this change'
          buttonName='Delete'
          open={openRejectionModal}
          onClose={() => setOpenRejectionModal(false)}
          onSubmit={(reason) => handleDeleteForum(reason)}
        />
      }
    </>
  );
};

export default Forum;
